/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
    },
    getters: {
       
    },
    mutations: {
       
    },
    actions: {
        async personalInfo({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                debugger
                const rsp = await axios.get(ApiUrl.user.info, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
    }
}